import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import PopularSection from './components/PopularSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '免费韩漫大全 - 韩国漫画在线阅读平台',
    description: '免费韩漫大全涵盖热血、恋爱、奇幻等全品类韩漫，无需注册即可在线阅读，每日更新最新章节。',
    url: 'https://www.freekcomic.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '免费韩漫大全',
      url: 'https://www.freekcomic.com',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.freekcomic.com/',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <LatestSection />
        <PopularSection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}